import { render } from "./FavoritesView.vue?vue&type=template&id=1012f95c&scoped=true"
import script from "./FavoritesView.vue?vue&type=script&lang=js"
export * from "./FavoritesView.vue?vue&type=script&lang=js"

import "./FavoritesView.vue?vue&type=style&index=0&id=1012f95c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1012f95c"]])

export default __exports__